import parse from 'html-react-parser';
import { files } from 'arquivos-estaticos';
import { IResources } from './interface-resources'
import { VariaveisAmbiente } from 'ambiente';
import { SaurusTema } from 'temas'

/* eslint-disable no-eval */
const resCardapioSaurus = () => {
  const fileReader = files();
  const getObject = () => {
    return {
      nome: 'Saurus Gestão',
      tituloPagina: 'Saurus Auth - Bem Vindo!',
      theme: SaurusTema,
      favIcon: fileReader.loadFavIcon('saurusGestao', 'favicon.ico'),
      logo: fileReader.loadLogo('saurusGestao', 'logo-saurus.png'),
      // Remover ao implementar o upload de gravatar - Vinicius Serafim 28-06-2021
      gravatarTemp: fileReader.loadGravatar('saurusGestao', 'logo-saurus.png'),
      footer: parse(`Saurus Software © - Copyright ${new Date().getFullYear()} - Todos os direitos reservados.` + (VariaveisAmbiente.isDev ? " - DEV" : ""))
    } as IResources;
  };

  return { getObject };
};

export const saurusGestao = resCardapioSaurus();
/* eslint-enable no-eval */
